import firebaseApp from "../../firebase/credenciales";
import { getFirestore, collection, doc, setDoc } from "firebase/firestore";

function añadir_boton_gastos(infoProducto) {
  const db = getFirestore(firebaseApp);
  const collectionRef = collection(db, "Botones_gastos/");
  const docRef = doc(collectionRef, infoProducto.valor);
  setDoc(docRef, infoProducto);      
}

export default añadir_boton_gastos;
